export const BROKERADMIN_ENROLLMENT_UPLOAD_COLUMNS = {
  givenName: 'Given Name',
  familyName: 'Family Name',
  email: 'Email',
  phoneNumber: 'Phone Number',
  dateOfBirth: 'Date of Birth',
  hireDate: 'Hire Date',
} as const;

export const TEAM_MEMBER_UPLOAD_COLUMNS = [
  BROKERADMIN_ENROLLMENT_UPLOAD_COLUMNS.givenName,
  BROKERADMIN_ENROLLMENT_UPLOAD_COLUMNS.familyName,
  BROKERADMIN_ENROLLMENT_UPLOAD_COLUMNS.email,
  BROKERADMIN_ENROLLMENT_UPLOAD_COLUMNS.phoneNumber,
  BROKERADMIN_ENROLLMENT_UPLOAD_COLUMNS.dateOfBirth,
  BROKERADMIN_ENROLLMENT_UPLOAD_COLUMNS.hireDate,
] as const;

export const TEAM_MEMBER_REQUIRED_UPLOAD_COLUMNS = [
  BROKERADMIN_ENROLLMENT_UPLOAD_COLUMNS.email,
] as const;

export const TEAM_MEMBER_UPLOAD_TEMPLATE_URL =
  '/assets/files/Wallit-team-members-upload-template.csv';
